import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "flex overflow-x-scroll hide-scrollbar" };
const _hoisted_2 = { class: "items-center flex" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("span", { class: "mx-2" }, [
    /*#__PURE__*/ _createElementVNode("svg", {
        width: "24px",
        height: "24px",
        class: "inline-block"
    }, [
        /*#__PURE__*/ _createElementVNode("path", { d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" })
    ])
], -1);
const _hoisted_4 = { class: "absolute top-10 left-8 inline-block z-50 bg-white border-2 rounded border-gray-200 z-60" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_folder_card = _resolveComponent("folder-card");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders, (folder, index) => {
                return (_openBlock(), _createElementBlock("div", {
                    key: folder.folderUuid,
                    class: "flex-shrink-0"
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        _hoisted_3,
                        _createVNode(_component_folder_card, {
                            open: _ctx.isMenuOpen,
                            "onUpdate:open": _cache[0] || (_cache[0] = ($event) => ((_ctx.isMenuOpen) = $event)),
                            onClick: ($event) => (_ctx.openFolder(folder)),
                            folder: folder,
                            showMenu: index === 0,
                            class: "rounded cursor-pointer text-sm w-48 md:w-60 md:my-2",
                            small: "",
                            onShowFolders: _cache[1] || (_cache[1] = id => _ctx.$emit('showFolders', id))
                        }, null, 8, ["open", "onClick", "folder", "showMenu"])
                    ])
                ]));
            }), 128))
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rootFolders, (rootFolder, index) => {
                return (_openBlock(), _createBlock(_component_folder_card, {
                    key: `${rootFolder.id}_${index}`,
                    folder: rootFolder,
                    class: "rounded cursor-pointer text-sm w-48 md:w-60 border-none p-2 hover:bg-blue-50",
                    onClick: ($event) => (_ctx.openFolder(rootFolder)),
                    showMenu: false
                }, null, 8, ["folder", "onClick"]));
            }), 128))
        ], 512), [
            [_vShow, _ctx.isMenuOpen]
        ])
    ], 64));
}
